<template>
    <form
        @submit.prevent.stop="validateForm"
        ref="form"
        :novalidate="novalidate"
        class="clearfix"
        :class="{ 'was-validated': wasValidated }"
    >
        <div v-if="errorMessages.length" class="container errors-container" style="overflow: auto">
            <!--overflow to prevent collapsing margin-->
            <div class="error-messages alert alert-danger" role="alert" ref="errorMessages">
                <ul class="list-unstyled mb-0">
                    <li
                        v-for="(error, index) in errorMessages"
                        class="errors-container__item"
                        :key="'error' + index"
                        v-html="error"
                    ></li>
                </ul>
            </div>
        </div>

        <slot></slot>
    </form>
</template>

<script>
//https://www.html5rocks.com/en/tutorials/forms/constraintvalidation/
export default {
    name: 'Form',
    data() {
        return {
            errorMessages: [],
            wasValidated: false
        };
    },
    props: {
        errors: Array,
        novalidate: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        validateForm(event) {
            const form = (event && event.currentTarget) || this.$refs.form;
            this.wasValidated = true;

            /*const emailFields = this.$refs.form.querySelectorAll('input[type="email"]') || [];
                Array.prototype.forEach.call(emailFields, input => {
                    input.setAttribute('pattern', "")
                });*/

            if (form.checkValidity()) {
                this.$emit('submitValid', event);
            } else {
                this.$emit('submitInvalid', event);
                //waiting until DOM is updated with validation classes (:invalid)
                this.$nextTick(() => {
                    const invalidElements = form.querySelectorAll(':invalid');
                    this.errorMessages = Array.prototype.map
                        .call(
                            invalidElements,
                            element =>
                                `${element.placeholder || element.name} - ${
                                    element.dataset.validationMessage || element.validationMessage
                                }`
                        )
                        .filter((message, index, messages) => {
                            return messages.indexOf(message) === index;
                        });
                });
            }
        },
        removeValidation() {
            this.wasValidated = false;
        }
    },
    watch: {
        errorMessages(messages) {
            if (messages.length) {
                //waiting until DOM is updated with errorMessages reactive property
                this.$nextTick(() => {
                    const errorsBounds = this.$refs.errorMessages.getBoundingClientRect();
                    const errorsOutsideViewport =
                        errorsBounds.top < 0 ||
                        errorsBounds.bottom > (window.innerHeight || document.documentElement.clientHeight);

                    //Inside an iframe
                    if (this.$root.$scrollToIframeTop) {
                        this.$root.$scrollToIframeTop();
                    } else if (errorsOutsideViewport) {
                        /**
                         * Such a complicated logic to fulfill cases when theme has a fixed top header, which will overlap
                         * errors list when scrolled
                         */
                        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                        const errorsDocumentOffset = errorsBounds.top + scrollTop;
                        const errorsMarginTop = Number.parseInt(
                            getComputedStyle(this.$refs.errorMessages).getPropertyValue('margin-top')
                        );
                        const mainContainerBounds = document.getElementById('animod').getBoundingClientRect();
                        const mainContainerDocumentOffset = mainContainerBounds.top + scrollTop;
                        window.scroll({
                            top: errorsDocumentOffset - mainContainerDocumentOffset - errorsMarginTop,
                            behavior: 'smooth'
                        });
                    }
                });
            }
        },
        errors: {
            handler(errors = []) {
                this.errorMessages = errors;
            },
            immediate: true
        }
    }
};
</script>

<style scoped lang="scss">
.errors-container__item {
    font-size: 16px;

    //server sometimes returns h2
    ::v-deep h2 {
        font-size: 16px;
        margin-bottom: 0;
    }
}
</style>
